import { useAuth } from "@/src/contexts/auth.context";
import { useMyWikiFeedback } from "@/src/services/wiki/wiki-feedback.hooks";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";
import { FeedbackListSkeleton } from "./feedback-card-skeleton";

/**
 * The current member's own wiki feedback submissions, newest first. No
 * moderation action here (marking resolved is admin-only, see
 * WikiFeedbackList) — just a status badge so the submitter can see whether
 * theirs has been looked at.
 */
export default function WikiMyFeedbackList() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { data: feedback = [], isLoading } = useMyWikiFeedback(
    user?.itemId ?? undefined,
  );

  if (isLoading) {
    return <FeedbackListSkeleton variant="mine" count={2} />;
  }

  if (feedback.length === 0) {
    return null;
  }

  return (
    <View className="gap-3 mt-4">
      <Text className="text-sm font-semibold text-onyx">
        {t("LABEL_MY_FEEDBACK")}
      </Text>

      <View className="gap-2">
        {feedback.map((item) => {
          const isResolved = item.resolved === true;
          return (
            <View
              key={item.ItemId}
              className="flex-col gap-3 p-3 md:border md:border-ash-3 rounded-xl"
            >
              <View className="bg-ash px-4 py-3 rounded-xl">
                <Text className="text-sm text-onyx" numberOfLines={6}>
                  {item.message}
                </Text>
              </View>

              <View className="flex-row items-center justify-between">
                <Text className="text-xs text-ash-2">
                  {new Date(item.CreatedDate).toLocaleDateString()}
                </Text>

                <View
                  className={`px-3 py-1 rounded-full ${
                    isResolved
                      ? "bg-primary-2 border border-primary"
                      : "border border-ash-3"
                  }`}
                >
                  <Text
                    className={`text-xs font-medium ${
                      isResolved ? "text-primary" : "text-ash-1"
                    }`}
                  >
                    {t(isResolved ? "LABEL_RESOLVED" : "LABEL_PENDING")}
                  </Text>
                </View>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
}
